import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// This file is autogenerated. Any changes will be overwritten in next build.

const Funnel = props => {
  const {
    size,
    color
  } = props;
  const sizeMap = {
    sm: 20,
    md: 24,
    lg: 28
  };
  let sizeValue = size;
  if (typeof size === 'number') {
    sizeValue = size;
  } else if (typeof size === 'string') {
    sizeValue = sizeMap[size];
  }
  return /*#__PURE__*/_jsxs("svg", {
    width: sizeValue,
    height: sizeValue,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M15.0769 17.8959V13.0826L19.4583 8.66032C19.8047 8.31158 19.9996 7.83838 20 7.34461V4.86188C20 4.36811 19.8053 3.89447 19.4591 3.54529C19.1129 3.19612 18.6433 3 18.1538 3H5.84623C5.35666 3 4.88707 3.19613 4.54086 3.54529C4.19467 3.89446 4 4.36812 4 4.86188V7.34461C4.00043 7.83839 4.19531 8.31158 4.54172 8.66032L8.92309 13.0826V19.1375C8.92288 19.7826 9.25383 20.382 9.79792 20.7214C10.342 21.0608 11.0215 21.0922 11.5939 20.8039L14.0555 19.5627H14.0553C14.3624 19.4081 14.6206 19.1702 14.8011 18.8758C14.9814 18.5814 15.0769 18.2421 15.0769 17.896L15.0769 17.8959ZM13.2307 17.8959L10.7691 19.1371L10.7693 12.3097L5.84619 7.34428V4.86155H18.1537V7.34428L13.2306 12.3097L13.2307 17.8959Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M19 13L19 17",
      stroke: color,
      strokeWidth: "1.5",
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M21 15H17",
      stroke: color,
      strokeWidth: "1.5",
      strokeLinecap: "round"
    })]
  });
};
export { Funnel };